import { cn } from '@/lib/utils';

/** Painel escuro dos Aces — mesmas cores dos cards, sem imagem de fundo. */
export const aceDarkPanelShellClass = cn(
  'relative overflow-hidden rounded-2xl border border-blue-900/60',
  'bg-[#030023] shadow-lg shadow-black/25 ring-1 ring-amber-400/20'
);

/** Degradê opaco — equivalente visual ao PowerDarkCardShell sem imagem. */
export const aceDarkPanelGradientLayers = (
  <>
    <div
      className="pointer-events-none absolute inset-0 bg-gradient-to-br from-[#000b6a] via-[#030023] to-[#01012e]"
      aria-hidden
    />
    <div
      className="pointer-events-none absolute inset-0 bg-gradient-to-b from-[#000b6a]/55 via-[#030023]/90 to-[#01012e]"
      aria-hidden
    />
    <div
      className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-amber-500/[0.06] via-transparent to-indigo-600/10"
      aria-hidden
    />
  </>
);

export const aceDarkControlClass = cn(
  'rounded-xl border border-solid border-[#1a2f5c] bg-[#01012e]',
  'shadow-[inset_0_1px_0_rgba(255,255,255,0.03)]',
  'outline-none ring-0',
  'transition-[border-color,box-shadow,background-color] duration-200',
  'hover:border-amber-400/30 hover:bg-[#030023]',
  'focus:border-amber-400/40 focus:bg-[#030023] focus:ring-2 focus:ring-amber-400/12',
  'focus-visible:outline-none',
  '[color-scheme:dark]'
);

export const aceDarkInputClass = cn(
  aceDarkControlClass,
  'appearance-none',
  '[&::-webkit-search-cancel-button]:hidden [&::-webkit-search-decoration]:hidden'
);

export const aceDarkMenuClass = cn(
  'overflow-hidden rounded-xl border border-solid border-[#1a2f5c] bg-[#030023]',
  'shadow-xl shadow-black/45 ring-1 ring-amber-400/15'
);

export const aceDarkChipClass = cn(
  'rounded-full border px-3 py-1.5 font-poppins text-xs font-semibold transition-all duration-200'
);

export const aceDarkChipInactiveClass = cn(
  'border-blue-900/60 bg-[#030023]/45 text-blue-100/80',
  'hover:border-amber-400/30 hover:bg-blue-950/50 hover:text-blue-50'
);

export const aceDarkChipActiveClass = cn(
  'border-amber-400/40 bg-amber-400/12 text-amber-100 ring-1 ring-amber-400/20'
);

export const aceDarkDividerClass = 'border-blue-900/50';

type AceDarkPanelShellProps = {
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
};

export function AceDarkPanelShell({ children, className, innerClassName }: AceDarkPanelShellProps) {
  return (
    <div className={cn(aceDarkPanelShellClass, className)}>
      {aceDarkPanelGradientLayers}
      <div className={cn('relative z-10', innerClassName)}>{children}</div>
    </div>
  );
}
